var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { t, T } from 'helpers/i18n';
import { toMoney, toPercentage, toDateTime } from 'helpers/Format';
import TicketsReport from '../components/TicketsReport';
import history from 'helpers/History';
import { TypeDiscount } from '../../DiscountReasons/Model';
var TicketGratis = /** @class */ (function (_super) {
    __extends(TicketGratis, _super);
    function TicketGratis() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.findUser = function (lista, id) {
            var result = lista.find(function (value) { return value.id === id; });
            return result ? result.name : '';
        };
        _this.handleOnSelectItem = function (item) {
            console.error(item.id);
            history.push("/tickets/".concat(item.id), item);
        };
        return _this;
    }
    TicketGratis.prototype.componentDidMount = function () {
        this.props.store.reports.readTicketGratis();
    };
    TicketGratis.prototype.render = function () {
        var reports = this.props.store.reports;
        var headers = ['businessUnit', 'operationLine', 'stretch', 'numero', 'user', 'datecheck', 'datevalited', 'discount', 'totalDiscount', 'terminal', 'netAmount', 'taxAmount', 'total'];
        var items = reports.ticketGratis;
        return (React.createElement(TicketsReport, { onSelectItem: this.handleOnSelectItem, search: true, header: headers, items: items, total: function (tickets) {
                return tickets.reduce(function (sum, item) {
                    if (item.daterefund)
                        return sum;
                    return item.total + sum;
                }, 0);
            }, loading: !reports.ticketGratisLoaded, keyExtractor: function (ticket) { return String(ticket.id); }, format: function (tickets) {
                return tickets.map(function (ticket) { return (__assign(__assign({}, ticket), { businessUnit: ticket.businessUnitName, operationLine: ticket.operationLineName, stretch: ticket.stretchName, datecheck: toDateTime(ticket.datecheck), datevalited: ticket.datevalited ? toDateTime(ticket.datevalited) : t('sinValidar'), discount: ticket.typeDiscount !== TypeDiscount.Fix && ticket.discount > 0 ? "".concat(T('percentage'), " ").concat(toPercentage(ticket.discount / 100)) :
                        (ticket.totalDiscount || ticket.discount) > 0 ? "".concat(T('fix'), " ").concat(toMoney(ticket.totalDiscount || ticket.discount)) : '', totalDiscount: toMoney(ticket.totalDiscount), codeDiscount: ticket.codeDiscount, netAmount: toMoney(ticket.netAmount), taxAmount: toMoney(ticket.taxAmount), 
                    /*taxBase: toMoney(ticket.taxBase),*/
                    total: toMoney(ticket.total), 
                    // user: ticket.user// this.findUser(this.props.store!.users.users, ticket.user_id)
                    user: ticket.username })); });
            } }));
    };
    TicketGratis = __decorate([
        inject('store'),
        observer
    ], TicketGratis);
    return TicketGratis;
}(Component));
export default TicketGratis;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketGratis.tsx
// module id = 1142
// module chunks = 0